import { useContext } from "react";
import { ActiveCurrencyContext } from "../contexts";

export function useActiveCurrency() {
  const activeTenantAndCurrencyContext = useContext(ActiveCurrencyContext);

  return activeTenantAndCurrencyContext;
}
